export default "__VITE_ASSET__DMW_2u21__"